<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Col, Row, Spinner } from '@sveltestrap/sveltestrap';

  import { BizCardItem } from '@client/pages/bizcards/components';

  import { BizCardsService } from '@client/services/bizcards';

  export let selected = null;

  let bizcards = [];
  let loadingList = true;

  onMount(async () => {
    bizcards = await BizCardsService.getAll();

    loadingList = false;
  });
</script>

{#if loadingList}
  <div class="text-center p-4">
    <Spinner color="primary" />
  </div>
{:else if !bizcards.length}
  <p class="text-muted">{$format('label.NO_RESULTS')}</p>
{:else}
  <div class="scrollable mt-2">
    <Row noGutters>
      {#each bizcards as card (card.rulename)}
        <Col sm={4} md={3} class="mb-3">
          <button
            class="bizcard-option p-2 w-100 text-center"
            class:active={selected === card.rulename}
            on:click={() => (selected = card.rulename)}
            data-rulename={card.rulename}
          >
            <BizCardItem rulename={card.rulename} />
          </button>
        </Col>
      {/each}
    </Row>
  </div>
{/if}

<style>
  .bizcard-option {
    background: none;
    border: 2px solid transparent;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: border-color 0.15s;
  }

  .bizcard-option:hover {
    border-color: var(--color-gray-400);
  }

  .bizcard-option.active {
    border-color: var(--bs-primary);
  }

  .scrollable {
    max-height: 40vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
